import { writable } from 'svelte/store';

 const registerUser = {}
// const registerUser = {
// 	title: "",
// 	firstName: "",
// 	lastName: "",
// 	address: "",
// 	//la_id: "", // what to do with this?
// 	postcode: "",
// 	isMemberOfCrownService: false,
// 	email: "",
// 	confirmEmail: "",
// 	Hometel: "",
// 	Worktel: "",
// 	Mobile: "",
// 	password: "",
// 	confirmPassword: "",
// 	isPrivacyPolicyAgreed: false,
//  hasStartedRegistration: false,	
// 	hasCompletedDetailsStep: false,
// 	hasCompletedContactDetailsStep: false,
// 	//hasCompletedRegistration: false,
// }

export const UserName = writable (null);

export const UserStore = writable({ });


const registerDetails = {
	title: {value: registerUser.title, isDirty: false, isValid: false},
	firstName: {value: registerUser.firstName, isDirty: false, isValid: false},
	lastName: {value: registerUser.lastName, isDirty: false, isValid: false},
	address: {value: registerUser.address, isDirty: false, isValid: false},
	postcode: {value: registerUser.postcode, isDirty: false, isValid: false},
	isMemberOfCrownService: {value: registerUser.isMemberOfCrownService, isDirty: false, isValid: true},
 }
 const registerContactDetails = {
	email: {value: registerUser.email, isDirty: false, isValid: false},
	confirmEmail: {value: registerUser.confirmEmail, isDirty: false, isValid: false},
	Hometel: {value: registerUser.Hometel, isDirty: false, isValid: false},
	Worktel: {value: registerUser.Worktel, isDirty: false, isValid: false},
	Mobile: {value: registerUser.Mobile, isDirty: false, isValid: false},
 }

 const registerPassword = {
	password: {value: registerUser.password, isDirty: false, isValid: false },
	confirmPassword: {value: registerUser.confirmPassword, isDirty: false, isValid: false },
	isPrivacyPolicyAgreed: {value: registerUser.isPrivacyPolicyAgreed, isDirty: false, isValid: true },
	//la_id: {value: registerUser.address.la_id, isDirty: false },
 }

// used for forms (validation)
 export const TempUserStore = writable({registerDetails, registerContactDetails, registerPassword });

